export default "__VITE_ASSET__DtlCEkmx__"